/**
 * Created by Vladislav on 07.03.2025.
 */

cleverapps.InitByFeature["weeklycup"] = function () {
    cleverapps.weeklyCup = new Cup(CupsConfig.TYPE_WEEKLY);
};